import { useIntl } from 'react-intl';
import { SortOption } from '../types';

export const useSortOptions = (): SortOption[] => {
  const { formatMessage } = useIntl();
  return [
    {
      sortType: 'default',
      label: formatMessage({ id: 'sortByDefault' }),
    },
    {
      sortType: 'byLicenseAsc',
      label: formatMessage({ id: 'sortVehicleNumberAZ' }),
    },
    {
      sortType: 'byLicenseDesc',
      label: formatMessage({ id: 'sortVehicleNumberZA' }),
    },
    {
      sortType: 'byLocationStatusAsc',
      label: formatMessage({ id: 'sortObuStatusOrder' }),
    },
    {
      sortType: 'byLocationStatusDesc',
      label: formatMessage({ id: 'sortObuStatusOrder' }),
    },
  ];
};
